import request from 'local_modules/request'
import { constants, modals } from 'helpers'
import { reducers, getState } from 'redux/core'
import actions from 'redux/actions'


const setFetching = (isFetching) => reducers.marketplace.adminStatisticsPage.setFetching(isFetching)

const fetchCategories = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.statisticsCategories + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminStatisticsPage.setCategories(data))
    .catch((error) => console.log(error))
}

const setCategories = (categories) => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.post(constants.marketplace.statisticsCategories + `/${tool}`, categories)
    .then(({ data }) => data)
    .catch((error) => {
      actions.modals.open(modals.Dialog, {
        title: 'Ошибка',
        text: JSON.stringify({ error })
      })
      console.log(error)
    })
}


export default {
  setFetching,

  fetchCategories,
  setCategories,
}
